import type {
  IndividualAffiliateRelationship,
  KYCRoleType,
} from '@anchorage/graphql/generated';
import { formatEnum } from '@anchorage/utils';

// Canonical display label for a KYC affiliate role/relationship enum value
// (KYCRoleType / IndividualAffiliateRelationship share the same string values).
// PARTICIPATING_MEMBER represents an Authorized User relation between an
// individual and an affiliate, so it displays as "Authorized user" rather
// than a literal enum-cased "Participating Member".
export function getAffiliateRoleLabel(
  role: KYCRoleType | IndividualAffiliateRelationship,
): string {
  switch (role) {
    case 'AML_SERVICE_PROVIDER':
      return 'AML service provider';
    case 'AUTHORIZED_SIGNATORY':
      return 'Authorized signatory';
    case 'PARTICIPATING_MEMBER':
      return 'Authorized user';
    case 'BENEFICIAL_OWNER':
      return 'Beneficial owner';
    case 'BOARD_DIRECTOR':
      return 'Director';
    case 'CONTROL_PERSON':
      return 'Control person';
    case 'GENERAL_PARTNER':
      return 'General partner';
    case 'GRANTOR_DONOR':
      return 'Grantor/settlor/donor';
    case 'GRANTOR':
      return 'Grantor/settlor';
    case 'DONOR':
      return 'Donor';
    case 'MANAGING_MEMBER':
      return 'Managing member';
    case 'TRUST_PROTECTOR':
      return 'Trust protector';
    case 'SENIOR_OFFICER':
      return 'Senior officer';
    case 'TRUSTEE_SUCCESSOR_TRUSTEE':
      return 'Trustee/Successor trustee';
    case 'FEEDER_FUND':
      return 'Feeder fund';
    case 'FUND_ADMINISTRATOR':
      return 'Fund administrator';
    case 'INVESTMENT_MANAGER':
      return 'Investment manager';
    case 'PARENT_ENTITY':
      return 'Parent entity';
    case 'OTHER':
      return 'Other';
  }
  return formatEnum(role, true);
}
